import styled from 'styled-components';

export const InDev = styled.div`
  position: absolute;
  right: 0;
  z-index: 10;

  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.dev};
  cursor: pointer;
  transition: width 0.3s ease-in-out, padding 0.3s ease-in-out;
  overflow: hidden;

  &:hover {
    width: auto;
    padding: 0 15px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;


    display: flex;
    gap: 8px;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;

      
  &:hover {
    display: flex;
    flex-direction: unset;
    justify-content: unset;
  }

`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;

  padding-top: 30px;

        
  &:hover {
    
    padding-top: unset;
  }
`;

export const Text = styled.div`
visibility: hidden;
  opacity: 0;
  white-space: nowrap;
  transform: translateX(-10px);
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  
  ${InDev}:hover & {
    visibility: visible;
    opacity: 1;
    transform: translateX(0);
  }
`;

